<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-modal
      id="filter"
      size="md"
      no-close-on-backdrop
      hide-footer
      title="FILTRAR"
    >
      <div class="row">
        <div class="col-md-12">
          <label>STATUS</label>
          <b-select
            :options="[{ value: 'ATIVO' }, { value: 'INATIVO' }]"
            v-model="status"
            value-field="value"
            text-field="value"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn @click="paginate" class="btn-filter" type="relief">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> VOLTAR
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">FAMILIARES</h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              @click="$bvModal.show('filter')"
              class="btn-filter mr-2"
              type="relief"
            >
              <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
            </v-btn>
            <v-btn
              v-if="permission('write', 'resident_relatives')"
              class="btn-add"
              v-on:click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>

          <!-- Modal create -->
          <b-modal
            no-close-on-backdrop
            size="xl"
            hide-footer
            id="popup"
            title="NOVO FAMILIAR"
          >
            <form v-on:submit="create" method="post">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    @click="errors = []"
                    class="nav-link active link-annotation-care"
                    id="nav-informacoes"
                    data-toggle="tab"
                    href="#informacoes"
                    role="tab"
                    aria-controls="informacoes"
                    aria-selected="true"
                    >INFORMAÇÕES</a
                  >
                  <a
                    @click="errors = []"
                    class="nav-link link-annotation-care"
                    id="nav-documentos"
                    data-toggle="tab"
                    href="#documentos"
                    role="tab"
                    aria-controls="documentos"
                    aria-selected="false"
                    >DOCUMENTOS</a
                  >
                  <a
                    @click="errors = []"
                    class="nav-link link-annotation-care"
                    id="nav-endereco"
                    data-toggle="tab"
                    href="#endereco"
                    role="tab"
                    aria-controls="endereco"
                    aria-selected="false"
                    >ENDEREÇO</a
                  >
                  <!-- <a
                    @click="errors = []"
                    class="nav-link link-annotation-care"
                    id="nav-status"
                    data-toggle="tab"
                    href="#status"
                    role="tab"
                    aria-controls="status"
                    aria-selected="false"
                    >ACESSO AO SISTEMA</a
                  > -->
                </div>
              </nav>
              <div class="tab-content">
                <div
                  class="tab-pane fade show active"
                  id="informacoes"
                  role="tabpanel"
                  aria-labelledby="nav-informacoes"
                >
                  <div class="row pt-3">
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <LabelRequiredField label="Nome" />
                      <input
                        type="text"
                        ref="autofocus"
                        v-model="name"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <LabelRequiredField label="Grau de parentesco" />
                      <select
                        v-model="type_of_customer_id"
                        class="form-control"
                      >
                        <option value>SELECIONE...</option>
                        <option
                          v-for="value in typesOfCustomer"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ String(value.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>1º Telefone</label>
                      <input
                        type="text"
                        v-mask="'(##) # ####-####'"
                        v-model="first_phone"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>2º Telefone</label>
                      <input
                        type="text"
                        v-mask="'(##) # ####-####'"
                        v-model="second_phone"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>Data de nascimento</label>
                      <input
                        type="date"
                        v-model="date_of_birth"
                        class="form-control"
                      />
                      <span>{{
                        date_of_birth && date_of_birth.length == 10
                          ? "Idade: " +
                            getAge(formatDateToUs(date_of_birth, true)) +
                            " anos"
                          : ""
                      }}</span>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>Gênero</label>
                      <select v-model="gender_id" class="form-control">
                        <option value>SELECIONE...</option>
                        <option
                          v-for="value in genders"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ String(value.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>Estado civil</label>
                      <select v-model="marital_status_id" class="form-control">
                        <option value>SELECIONE...</option>
                        <option
                          v-for="value in maritalStatus"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ String(value.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                      <label>IE</label>
                      <input type="text" v-model="ie" class="form-control" />
                    </div>
                    <div class="col-md-12">
                      <label>E-mail</label>
                      <input
                        type="email"
                        v-model="email"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="documentos"
                  role="tabpanel"
                  aria-labelledby="nav-documentos"
                >
                  <div class="row pt-3">
                    <div class="col-xl-3 xol-lg-3 col-md-6 col-sm-6 col-12">
                      <label>CPF</label>
                      <BInputCPF v-model="cpf" />
                    </div>
                    <div class="col-xl-3 xol-lg-3 col-md-6 col-sm-6 col-12">
                      <label>RG</label>
                      <input type="text" v-model="rg" class="form-control" />
                    </div>
                    <div class="col-xl-3 xol-lg-3 col-md-6 col-sm-6 col-12">
                      <label>Orgão expedidor</label>
                      <input
                        type="text"
                        v-model="issuing_body"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-3 xol-lg-3 col-md-6 col-sm-6 col-12">
                      <label>Data de emissão</label>
                      <input
                        type="date"
                        v-model="date_of_issue"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="endereco"
                  role="tabpanel"
                  aria-labelledby="nav-endereco"
                >
                  <div class="row pt-3">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                      <label>CEP</label>
                      <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                    </div>
                    <div class="col-xl-7 col-lg-7 col-md-7 col-sm-8 col-12">
                      <label>Endereço</label>
                      <input
                        type="text"
                        v-model="address"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12">
                      <label>Nº</label>
                      <input
                        type="text"
                        v-model="number_address"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label>Bairro</label>
                      <input
                        type="text"
                        v-model="neighborhood"
                        class="form-control"
                      />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label>Cidade</label>
                      <input type="text" v-model="city" class="form-control" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label>Estado</label>
                      <select v-model="uf_id" class="form-control">
                        <option value>SELECIONE...</option>
                        <option
                          v-for="value in ufs"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="status"
                  role="tabpanel"
                  aria-labelledby="nav-status"
                >
                  <div class="row pt-3">
                    <div class="col-md-12">
                      <LabelRequiredField label="E-mail" />
                      <input
                        type="email"
                        v-model="email"
                        class="form-control"
                      />
                    </div>
                    <div class="col-md-6">
                      <LabelRequiredField label="Senha" />
                      <input
                        type="password"
                        v-model="password"
                        class="form-control"
                      />
                    </div>
                    <div class="col-md-6">
                      <LabelRequiredField label="Confirmação da senha" />
                      <input
                        type="password"
                        v-model="confirm_password"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
              <div class="row">
                <div class="col-md-12 text-right">
                  <v-btn
                    :disabled="loadingCreate"
                    type="submit"
                    class="btn-save"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingCreate ? "Carregando" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </b-modal>
          <!-- /Modal create -->

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-0 pb-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="Pesquisar familiares"
              dense
              outlined
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="customers.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="customers.length > 0"
          dense
          :headers="headers"
          :items="customers"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.linked_residents`]="{ item }">
            <span v-show="item.linked_residents.length == 0">Sem vinculo</span>
            <ul v-show="item.linked_residents.length > 0">
              <li v-for="resident in item.linked_residents" :key="resident.id">
                {{ resident.name }}
              </li>
            </ul>
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import ErrorsMessages from "../templates/Components/ErrorsMessages";

import BInputCEP from "../templates/Components/BInputCEP.vue";
import BInputCPF from "../templates/Components/BInputCPF.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import { arrayDiffCustomerHasResident } from "../lib/arrayDiff";

import { formatDate, formatDateToUs } from "../lib/format";

import { getAge } from "../lib/getAgeByDate";

import routes from "../routes";

import { getStatic } from "../lib/functions";

export default {
  name: "RestHomeCustomer",

  components: {
    NavBar,
    AuthBySessionExpired,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
    BInputCEP,
    BInputCPF,
  },

  data() {
    return {
      status: "ATIVO",
      search: "",
      searchIsCustomerHasResident: "",
      searchIsNotCustomerHasResident: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "GRAU DE PARENTESCO", value: "type_of_customer_name" },
        {
          text: "RESIDENTES VINCULADOS",
          value: "linked_residents",
        },
      ],
      customers: [],
      typesOfCustomer: [],
      maritalStatus: [],
      isNotCustomerHasResidentAll: [],
      isCustomerHasResident: [],
      isNotCustomerHasResident: [],
      genders: [],
      ufs: [],
      id: "",
      type_of_customer_id: "",
      gender_id: "",
      marital_status_id: "",
      uf_id: "",
      name: "",
      kinship: "",
      rg: "",
      cpf: "",
      issuing_body: "",
      date_of_issue: "",
      first_phone: "",
      second_phone: "",
      email: "",
      password: "",
      confirm_password: "",
      date_of_birth: "",
      cep: "",
      address: "",
      number_address: "",
      complement: "",
      city: "",
      neighborhood: "",
      ie: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingCustomerUpdate: false,
      loading: true,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    getAge,
    formatDate,
    formatDateToUs,
    arrayDiffCustomerHasResident,

    handleToBack: () => routes.go(-1),

    handleClickRowTable(item) {
      routes.push({ path: `customer/${item.id}`, params: { id: item.id } });
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      if (this.errors.length == 0) await this.paginate();
      if (this.errors.length > 0) return;
      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.genders = (await getStatic("/genders", true)).genders;
        this.maritalStatus = (
          await getStatic("/rest-home/marital-status/all", true)
        ).marital_status;
        this.typesOfCustomer = (
          await getStatic("/types-of-customers", true)
        ).types;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { status } = this;

        let params = { status };

        const response = await api.get("/rest-home/customer/paginate", {
          params,
        });

        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.customers = customers;
        }

        this.$bvModal.hide("filter");
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const {
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          kinship,
          first_phone,
          second_phone,
          email,
          password,
          confirm_password,
          date_of_birth,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
        } = this;

        let params = {
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          kinship,
          first_phone,
          second_phone,
          email,
          password,
          confirm_password,
          date_of_birth,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
        };

        const response = await api.post("/rest-home/customer", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("popup");
          this.paginate();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreate() {
      this.gender_id = "";
      this.type_of_customer_id = "";
      this.marital_status_id = "";
      this.uf_id = "";
      this.name = "";
      this.kinship = "";
      this.rg = "";
      this.cpf = "";
      this.issuing_body = "";
      this.date_of_issue = "";
      this.first_phone = "";
      this.second_phone = "";
      this.email = "";
      this.password = "";
      this.confirm_password = "";
      this.date_of_birth = "";
      this.cep = "";
      this.address = "";
      this.number_address = "";
      this.city = "";
      this.neighborhood = "";
      this.ie = "";

      this.errors = [];
      this.$bvModal.show("popup");
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },
  },
};
</script>
